import type { FC, PropsWithChildren } from 'react';

import { GridContainer } from '@xing-com/xing-grid';

import { useIsWebview } from '../../hooks/use-is-webview/use-is-webview';
import { ZenView } from '../zen-view/zen-view';

type PageLayoutProps = {
  isZenView?: boolean;
};
export const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({
  children,
  isZenView,
}) => {
  const isWebview = useIsWebview();

  if (isWebview) {
    return <>{children}</>;
  }

  if (isZenView) {
    return <ZenView>{children}</ZenView>;
  }

  return <GridContainer>{children}</GridContainer>;
};
